import React from "react";
import {Link} from "react-router-dom";

const Error500 = () => {
  return (
    <div className="authincation ">
      <div className="container ">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-5">
            <div className="form-input-content text-center error-page">
              <h1 className="error-text font-weight-bold">500</h1>
              <h4>
                <i className="fa fa-times-circle text-danger" /> Erreur interne
                du serveur
              </h4>

              <p>
                Vous n’avez pas l’autorisation de consulter cette ressource.
              </p>

              <div>
                <Link className="btn btn-primary" to="/">
                  Retour à l’accueil
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error500;
